"use client";

import { c as _c } from "react/compiler-runtime";
import { Loader2, Mail } from "lucide-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import UserParticipationForm from "@/app/(main)/_club_components/user-participation-form";
import Button from "@/components/button";
import { ClubContext } from "@/context/club-provider";
import { sidebarContext } from "@/context/sidebar-context";
import { clubFormats } from "@/lib/club-constants";
import { Club } from "@/TS/Interfaces/global_interfaces";

/** Boutons « Participer à une réunion » / « Contacter le président ». */
export default function UserParticipationActions(t0) {
  const $ = _c(32);
  const {
    club,
    isLogged,
    presidentEmail,
    className,
    onParticipate
  } = t0;
  const {
    setVal
  } = useContext(sidebarContext);
  const {
    setFormat
  } = useContext(ClubContext);
  const [isParticipationLoading, setIsParticipationLoading] = useState(false);
  const [isMailLoading, setIsMailLoading] = useState(false);
  const participationTimeoutRef = useRef(undefined);
  let t1;
  if ($[0] !== club.format || $[1] !== setFormat) {
    t1 = () => {
      setFormat(clubFormats[club.format as keyof typeof clubFormats]);
    };
    $[0] = club.format;
    $[1] = setFormat;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== club || $[4] !== setFormat) {
    t2 = [club, setFormat];
    $[3] = club;
    $[4] = setFormat;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => () => clearTimeout(participationTimeoutRef.current);
    t4 = [];
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[8] !== isMailLoading) {
    t5 = () => {
      if (!isMailLoading) {
        return;
      }
      const stopMailLoading = () => setIsMailLoading(false);
      window.addEventListener("blur", stopMailLoading);
      const timeout = setTimeout(stopMailLoading, 3000);
      return () => {
        window.removeEventListener("blur", stopMailLoading);
        clearTimeout(timeout);
      };
    };
    t6 = [isMailLoading];
    $[8] = isMailLoading;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== club || $[12] !== isLogged || $[13] !== onParticipate || $[14] !== setVal) {
    t7 = () => {
      setIsParticipationLoading(true);
      participationTimeoutRef.current = setTimeout(() => {
        const openForm = () => setVal(<UserParticipationForm club={club} isLogged={isLogged} />);
        if (onParticipate) {
          onParticipate(openForm);
        } else {
          openForm();
        }
        setIsParticipationLoading(false);
      }, 300);
    };
    $[11] = club;
    $[12] = isLogged;
    $[13] = onParticipate;
    $[14] = setVal;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const handleParticipationClick = t7;
  const t8 = className ?? "flex flex-col lg:flex-row items-center justify-center gap-3 w-full lg:w-auto lg:gap-4";
  const t9 = isParticipationLoading ? "invisible" : "";
  let t10;
  if ($[16] !== t9) {
    t10 = <span className={t9}>Participer à une réunion</span>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== isParticipationLoading) {
    t11 = isParticipationLoading && <span className="absolute inset-0 flex items-center justify-center"><Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" /></span>;
    $[18] = isParticipationLoading;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== handleParticipationClick || $[21] !== isParticipationLoading || $[22] !== t10 || $[23] !== t11) {
    t12 = <Button onClick={handleParticipationClick} disabled={isParticipationLoading} className="w-full lg:w-auto relative" aria-label={"Participer \xE0 une r\xE9union de d\xE9couverte avec ce club"}>{t10}{t11}</Button>;
    $[20] = handleParticipationClick;
    $[21] = isParticipationLoading;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== isMailLoading || $[26] !== presidentEmail) {
    t13 = presidentEmail && <a href={`mailto:${presidentEmail}`} onClick={() => setIsMailLoading(true)} aria-busy={isMailLoading} className="button border-primary text-primary bg-transparent hover:bg-primary hover:text-white hover:bg-opacity-80 inline-flex items-center justify-center gap-2 no-underline w-full lg:w-auto" aria-label={"Contacter le pr\xE9sident du club par email"}>{isMailLoading ? <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" /> : <Mail className="w-4 h-4" aria-hidden="true" />}Contacter le président</a>;
    $[25] = isMailLoading;
    $[26] = presidentEmail;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13 || $[30] !== t8) {
    t14 = <div className={t8}>{t12}{t13}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t8;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
}